/// <reference types="gtag.js" />

export function setSignedInProperty(isSignedIn: boolean) {
  if (!window?.gtag) return;
  // user_properties はオブジェクト。値は文字列推奨。
  window.gtag('set', {
    user_properties: { signed_in: isSignedIn ? 'true' : 'false' },
  });
}
